import * as React from "react";
function SvgIcMapThemes(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.234 16.869V4.414l4.693 2.429v9.47l.839-.888V6.833l4.391-2.403V11h.846V3.008l-5.663 3.1-5.536-2.865-5.75 3.09v14.364l5.758-3.094 2.617 1.354.604-.64-2.799-1.448zm-.849 0L3.898 19.28V6.834l4.487-2.412v12.446zm13.757-3.182L20.445 12l-7.054 7.07L13 21.143l2.084-.383 7.058-7.074zm-2.693.276l.997-1 .73.727-.994.997-.733-.724zm-5.428 5.438l4.946-4.957.733.723-4.95 4.962-.897.164.168-.892z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcMapThemes;
